/**
 * Config do Unleash Proxy (FlagProvider).
 * O nome do environment deve ser idêntico ao do painel Unleash (ex.: development, dev, prd).
 */
export const UNLEASH_APP_NAME = 'lojas-web';

export const getUnleashProxyUrl = () =>
  process.env.IC_ENV === 'production'
    ? 'https://unleash-proxy.instacarro.com/proxy'
    : 'https://proxy-unleash.instacarro.com/proxy';

export const getUnleashEnvironment = () => {
  if (process.env.IC_ENV === 'production') {
    return 'prd';
  }

  // Painel pode mostrar "Development"; slug no proxy costuma ser "dev"
  return process.env.REACT_APP_UNLEASH_ENV || 'dev';
};

export const unleashConfig = {
  url: getUnleashProxyUrl(),
  clientKey: 'secret-one',
  refreshInterval: 60,
  appName: UNLEASH_APP_NAME,
  environment: getUnleashEnvironment(),
};
